import { render, staticRenderFns } from "./ClientPhysicalApiEdit.vue?vue&type=template&id=9dbc109a&scoped=true&"
import script from "./ClientPhysicalApiEdit.vue?vue&type=script&lang=js&"
export * from "./ClientPhysicalApiEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbc109a",
  null
  
)

export default component.exports